import { useEffect, useState } from "react";

export function useOrderTimer(createdAt: number) {
  const [elapsed, setElapsed] = useState(() => {
    const now = Date.now();
    return Math.floor((now - createdAt) / 1000);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      setElapsed(Math.floor((now - createdAt) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return elapsed;
}
